import React from 'react'
import { FormControlLabel, Switch } from '@mui/material'

/**
 * @typedef {object} FilterSwitchProps
 * @property {boolean} [disabled] - Si es true, el switch está deshabilitado.
 * @property {string} label - La etiqueta que se muestra junto al switch.
 * @property {boolean} checked - El estado actual del switch (encendido/apagado).
 * @property {function(Event, boolean): void} onChange - Callback ejecutado cuando cambia el estado del switch.
 * @property {string} [name] - El nombre del campo para identificación en formularios.
 * @property {string} [color] - Color del switch cuando está activo ('primary', 'secondary', 'default').
 */

/**
 * Un componente de switch (interruptor) para filtros con etiqueta posicionada a la izquierda.
 *
 * Proporciona un control de tipo toggle/switch ideal para filtros binarios como "Activo/Inactivo",
 * "Mostrar archivados", etc. La etiqueta se posiciona a la izquierda del switch, siguiendo
 * convenciones comunes de interfaz de filtros.
 *
 * @component
 * @example
 * const MyFilters = () => {
 *   const [showArchived, setShowArchived] = useState(false);
 *
 *   const handleChange = (event, checked) => {
 *     setShowArchived(checked);
 *     // Aplicar filtro...
 *   };
 *
 *   return (
 *     <FilterSwitch
 *       label="Mostrar archivados"
 *       checked={showArchived}
 *       onChange={handleChange}
 *       name="showArchived"
 *       color="primary"
 *     />
 *   );
 * };
 *
 * @param {FilterSwitchProps} props - Las props del componente FilterSwitch.
 */
export const FilterSwitch = ({ disabled, label, ...props }) => {
  return (
    <FormControlLabel
      variant="outlined"
      disabled={disabled}
      label={label}
      control={<Switch {...props} />}
      labelPlacement="start"
    />
  )
}

export default FilterSwitch
